import { render, staticRenderFns } from "./TaxReturnEmployeeSection.vue?vue&type=template&id=31f3032c&scoped=true&"
import script from "./TaxReturnEmployeeSection.vue?vue&type=script&lang=js&"
export * from "./TaxReturnEmployeeSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31f3032c",
  null
  
)

export default component.exports